import { Tooltip } from '@/components/ui/Tooltip';
import { MCPIcon } from '@/features/mcp/MCPIcon';

import type { MeetingNoteSource } from '@littlebird/sdk';

export function MeetingNoteSourceBadge({
  source,
}: {
  source: MeetingNoteSource;
}) {
  return (
    <Tooltip label={`From ${source.displayName}`}>
      <span
        className="inline-flex shrink-0"
        aria-label={`From ${source.displayName}`}
      >
        <MCPIcon server={{ name: source.displayName }} className="size-3.5" />
      </span>
    </Tooltip>
  );
}
